import React from "react";
import { Typography } from "@material-ui/core";
import type { Selection } from "../uiTypes";
import QuestionPreviewWrapper from "./previews/QuestionPreview";
import QuestionnairePreview from "./previews/QuestionnairePreview";
import QuestionGroupPreview from "./previews/QuestionGroupPreview";
import { previewStyles as styles } from "./previews/previewStyles";
import type { PreviewAttrs } from "../api";

type PreviewProps = {
  selection: Selection;
  isExpanded: boolean;
  onToggleExpand: () => void;
  currentPageIndex?: number;
  onPageIndexChange?: (index: number) => void;
  attrs: PreviewAttrs;
  onAttrsChange: (attrs: PreviewAttrs) => void;
};

const Preview: React.VFC<PreviewProps> = ({
  selection,
  isExpanded,
  onToggleExpand,
  currentPageIndex,
  onPageIndexChange,
  attrs,
  onAttrsChange,
}) => {
  if (!selection) {
    return (
      <div className={styles.empty}>
        <Typography color="textSecondary">Select an item to preview</Typography>
      </div>
    );
  }

  if (selection.type === "question") {
    return (
      <QuestionPreviewWrapper
        id={selection.id}
        isExpanded={isExpanded}
        onToggleExpand={onToggleExpand}
        attrs={attrs}
        onAttrsChange={onAttrsChange}
      />
    );
  }

  if (selection.type === "questionnaire") {
    return (
      <QuestionnairePreview
        id={selection.id}
        isExpanded={isExpanded}
        onToggleExpand={onToggleExpand}
        currentPageIndex={currentPageIndex}
        onPageIndexChange={onPageIndexChange}
        attrs={attrs}
        onAttrsChange={onAttrsChange}
      />
    );
  }

  if (selection.type === "questionGroup") {
    return (
      <QuestionGroupPreview
        id={selection.id}
        isExpanded={isExpanded}
        onToggleExpand={onToggleExpand}
        attrs={attrs}
        onAttrsChange={onAttrsChange}
      />
    );
  }

  return null;
};

export default Preview;
